import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function RequesterVerify() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      navigate("/my-bookings");
      return;
    }
    api.requesterVerifyLogin(token)
      .then((r) => {
        localStorage.setItem("requester_token", r.data.token);
        navigate("/my-bookings");
      })
      .catch((err) => {
        setError(err.response?.data?.detail || "Login link is invalid or expired. Please request a new one.");
      });
  }, []);

  if (error) {
    return (
      <div className="min-h-screen bg-[#fcfdfc] flex items-center justify-center px-4" style={{ fontFamily: "'Public Sans', sans-serif" }}>
        <div className="text-center max-w-sm">
          <p className="text-red-600 font-semibold mb-4">{error}</p>
          <a href="/my-bookings" className="text-green-700 font-medium hover:underline">Go to login</a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#fcfdfc] flex items-center justify-center">
      <Loader2 className="w-8 h-8 animate-spin text-green-700" />
    </div>
  );
}
